/**
 * Register every data-source connector manifest at startup.
 *
 * Called from dashboard + react-app bootstraps alongside
 * `registerDefaultProfiles()`. Each domain contributes its own
 * registration function from `{domain}/connectors/`. Idempotent — safe
 * to call repeatedly (duplicate-id throws are caught inside each
 * domain's safeRegister helper).
 */
import { registerDataBindingConnectors } from '../../domains/data-binding/connectors';
import { registerNetworkConnectors } from '../../domains/network/connectors';
import { registerSoftwareDesignConnectors } from '../../domains/software-design/connectors/data-connectors';
import { registerGrcCatalogConnectors } from '../../domains/grc-catalog/connectors';
import { getConnector } from './connectorRegistry';

export function registerDefaultConnectors(): void {
  registerDataBindingConnectors();
  registerNetworkConnectors();
  registerSoftwareDesignConnectors();
  registerGrcCatalogConnectors();
}

/**
 * Defensive bootstrap for code-split import surfaces.
 *
 * Dashboard and editor entrypoints still register defaults eagerly. Import
 * surfaces call this before reading the registry so a preview chunk cannot
 * render an empty picker when its entrypoint bootstrap has not populated the
 * registry instance yet.
 */
export function ensureDefaultConnectorsRegistered(): void {
  if (getConnector('csv-upload')) return;
  registerDefaultConnectors();
}
